import Api from '@/shared/services/Api'


export default 
{

	get() {
		return Api().get('terms-get')
	},

	update(data) {
		return Api().post('terms-update', data)
	},

}